import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { siteConfig } from '../config/siteConfig';

const RotatingTestimonials = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: t('home.testimonial.quote'),
      author: t('home.testimonial.author'),
      type: t('home.testimonial.type')
    },
    {
      quote: t('home.testimonial2.quote'),
      author: t('home.testimonial2.author'),
      type: 'Verified Customer • Water Damage Restoration'
    },
    {
      quote: t('home.testimonial3.quote'),
      author: t('home.testimonial3.author'),
      type: 'Verified Customer • Fire Damage Restoration'
    },
    {
      quote: t('home.testimonial4.quote'),
      author: t('home.testimonial4.author'),
      type: 'Verified Customer • Mold Remediation'
    },
    {
      quote: t('home.testimonial5.quote'),
      author: t('home.testimonial5.author'),
      type: 'Verified Customer • Water Damage Restoration'
    },
    {
      quote: t('home.testimonial6.quote'),
      author: t('home.testimonial6.author'),
      type: 'Verified Customer • General Restoration'
    }
  ];

  const sectionStyle = {
    padding: 'clamp(2rem, 5vw, 5rem) 0'
  };

  // Auto-rotate testimonials every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  return (
    <section style={{ ...sectionStyle, backgroundColor: 'white' }}>
      <div className="ffp-container-reading">
        <h2 style={{
          fontSize: 'clamp(1.5rem, 4vw, 2.25rem)',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '0.5rem',
          color: siteConfig.colors.secondary,
          fontFamily: siteConfig.fonts.heading
        }}>
{t('home.testimonialSection.title')}
        </h2>
        <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)' }}>
          <span style={{ color: siteConfig.colors.primary, fontSize: 'clamp(1.25rem, 3vw, 1.5rem)' }}>→</span>
        </div>

        {/* Main Rotating Testimonial */}
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          position: 'relative'
        }}>
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 'clamp(2rem, 5vw, 3rem)',
            borderRadius: '12px',
            textAlign: 'center',
            minHeight: '250px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            transition: 'all 0.5s ease-in-out',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Navigation Arrows */}
            <button
              onClick={goToPrevious}
              aria-label="Previous testimonial"
              style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.9)',
                border: 'none',
                borderRadius: '50%',
                width: '44px',
                height: '44px',
                cursor: 'pointer',
                fontSize: '18px',
                color: siteConfig.colors.secondary,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                zIndex: 10
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'white';
                e.target.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.9)';
                e.target.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              ←
            </button>

            <button
              onClick={goToNext}
              aria-label="Next testimonial"
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.9)',
                border: 'none',
                borderRadius: '50%',
                width: '44px',
                height: '44px',
                cursor: 'pointer',
                fontSize: '18px',
                color: siteConfig.colors.secondary,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                zIndex: 10
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'white';
                e.target.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.9)';
                e.target.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              →
            </button>

            <div style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1rem' }}>⭐⭐⭐⭐⭐</div>
            <p style={{
              fontSize: 'clamp(1rem, 3vw, 1.25rem)',
              fontStyle: 'italic',
              color: '#374151',
              marginBottom: '1.5rem',
              lineHeight: '1.6',
              maxWidth: '700px',
              margin: '0 auto 1.5rem auto'
            }}>
              {testimonials[currentIndex].quote}
            </p>
            <p style={{
              fontWeight: 'bold',
              color: siteConfig.colors.secondary,
              fontSize: 'clamp(0.875rem, 2.5vw, 1rem)',
              marginBottom: '0.5rem'
            }}>
              {testimonials[currentIndex].author}
            </p>
            <p style={{
              fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
              color: siteConfig.colors.primary,
              fontWeight: '500'
            }}>
              {testimonials[currentIndex].type}
            </p>
          </div>

          {/* Dot Indicators - 44px touch targets with 12px visual dots */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1rem',
            gap: '0'
          }}>
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                aria-label={`Go to testimonial ${index + 1}`}
                style={{
                  width: '44px',
                  height: '44px',
                  border: 'none',
                  cursor: 'pointer',
                  background: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0
                }}
              >
                <span
                  style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    transition: 'all 0.3s ease',
                    backgroundColor: index === currentIndex ? siteConfig.colors.primary : '#d1d5db',
                    display: 'block'
                  }}
                />
              </button>
            ))}
          </div>

          {/* Progress Bar */}
          <div style={{
            marginTop: '1rem',
            width: '100%',
            height: '3px',
            backgroundColor: '#e5e7eb',
            borderRadius: '2px',
            overflow: 'hidden'
          }}>
            <div
              key={currentIndex} // Force re-render on slide change
              style={{
                height: '100%',
                backgroundColor: siteConfig.colors.primary,
                borderRadius: '2px',
                width: '0%',
                animation: 'progress 5s linear forwards',
                transformOrigin: 'left'
              }}
            />
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes progress {
            0% { width: 0%; }
            100% { width: 100%; }
          }
        `
      }} />
    </section>
  );
};

export default RotatingTestimonials;